import React, {useEffect} from "react";
import Header from "../../component/Header/Header";
import {useDispatch, useSelector} from "react-redux";
import QuoteButton from "../../component/quoteButton";
import Grid from "@material-ui/core/Grid";
import {updateFilters} from "../../../core/redux/ActionCreator";
import Offer from "../../component/Offers/offer";
import Analytics from "../../../shared/util/analytics";


const CompareTires = () => {
    const dispatch = useDispatch();
    const tires = useSelector(state => state.searchResultReducer.filteredResults);
    const adobeFlag = useSelector(state => state.appParamsReducer.adobeScriptLoadFlag);
    const analytics = Analytics();
    let selections = [];
    let gridSize = 12;

    tires.forEach((tire, index) => {
        if (tire.selected) selections.push(index)
    });

    if(selections.length === 3){
        gridSize = 4;
    }
    else if (selections.length === 2){
        gridSize = 6
    }

    const tireImage = selections.map(value =><Grid className={'gridContent'} item xs={gridSize}>
        <div className={"tableImage"}> {<img src={"../tirefinder/api/v1/blob/" + tires[value].imageName} alt="Tire" style={{
            maxWidth: '100%', marginLeft: '2px', marginRight: '2px', height: 'auto' }}/>}</div></Grid>);
    const tireBrand = selections.map(value => <Grid className={'gridContent'} item xs={gridSize}>
        <div className={"tireBrandCompare"}> {tires[value].brand}</div>
    </Grid>);
    const tireName = selections.map(value => <Grid container className={'gridContent'} item xs={gridSize}>
        <div className={"tireNameCompare"}>{tires[value].name}</div>
    </Grid>);
    const tireButton = selections.map(value => <Grid className={'gridContent'} item xs={gridSize}>
        <div className={"tableButton"}>{<QuoteButton
            gmPartNum={tires[value].gmPartNum} isCompare/>}</div>
    </Grid>);
    const originalE = selections.map(value => <Grid className={'gridContent'} item xs={gridSize}>
        <div className={"tableDataCompare"}>{originalEquipment(tires[value].originalEquipment)}</div>
    </Grid>);
    const tirePrice = selections.map(value => <Grid className={'gridContent'} item xs={gridSize}>
        {tires[value].priceFailed
            ?<div>Contact Dealer</div>
            :<div className={"tableDataCompare"}>${tires[value].price} each</div>
        }

    </Grid>);
    const tireType = selections.map(value => <Grid className={'gridContent'} item xs={gridSize}>
        <div className={"tableDataCompare"}>{tires[value].tireType}</div>
    </Grid>);
    const tireSidewall = selections.map(value => <Grid className={'gridContent'} item xs={gridSize}>
        <div className={"tableDataCompare"}>{tires[value].sidewall}</div>
    </Grid>);
    const tireLoad = selections.map(value => <Grid className={'gridContent'} item xs={gridSize}>
        <div className={"tableDataCompare"}>{tires[value].load}</div>
    </Grid>);
    const tireSpeed = selections.map(value => <Grid className={'gridContent'} item xs={gridSize}>
        <div className={"tableDataCompare"}>{tires[value].speedRating}</div>
    </Grid>);
    const tireRange = selections.map(value => <Grid className={'gridContent'} item xs={gridSize}>
        <div className={"tableDataCompare"}>{tires[value].ply}</div>
    </Grid>);
    const tireWarranty = selections.map(value => <Grid className={'gridContent'} item xs={gridSize}>
        <div className={"tableDataCompare"}>{tires[value].warranty}</div>
    </Grid>);
    const tireGmPartNum = selections.map(value => <Grid className={'gridContent'} item xs={gridSize}>
        <div className={"tableDataCompare"}>{tires[value].gmPartNum}</div>
    </Grid>);
    const updateFilter = useSelector(state => state.searchResultReducer.updateFilter);

    if (updateFilter) {
        dispatch(updateFilters({updateFilter: false}));
    }

    useEffect(() => {
        if (adobeFlag) {
            analytics.trackPage('compare-tires');
            // eslint-disable-next-line no-undef
            _satellite.track('compare-tires');
            console.log('Analytics Added for Page to DOM: Compare Tires using JQuery');
        }
        // eslint-disable-next-line
    }, [adobeFlag]);

    function originalEquipment(orginalE) {
        let result;
        if (orginalE) {
            result = "Original Equipment"
        } else {
            result = "Replacement Equipment"
        }
        return result;
    }


    return (
        <>
            <Offer/>
            <br/>
            <Header title='Search Results' page='/searchResult' viewQuote={true}/>

            <div className={"infoContainer"}>
                <div className={"pageTitle"}>
                    Compare {selections.length} Tires
                </div>
            <Grid className={'whiteBackground'} container spacing={1} xs={12}>
                    {tireImage}
                    {tireBrand}
                    {tireName}
                    {tireButton}
                <br/>
                <Grid className={'gridHeader'} item xs={12}>
                <div className={"tableHeader"}>Equipment</div>
                </Grid>
                            {originalE}
                <Grid className={'gridHeader'} item xs={12}>
                <div className={"tableHeader"}>Price</div>
                </Grid>
                            {tirePrice}

                <Grid className={'gridHeader'} item xs={12}>
                            <div className={"tableHeader"}>Type</div>
                        </Grid>

                            {tireType}
                <Grid className={'gridHeader'} item xs={12}>
                            <div className={"tableHeader"}>Sidewall</div>
                        </Grid>

                            {tireSidewall}

                <Grid className={'gridHeader'} item xs={12}>
                            <div className={"tableHeader"}>Load</div>
                        </Grid>

                            {tireLoad}

                <Grid className={'gridHeader'} item xs={12}>
                            <div className={"tableHeader"}>Speed</div>
                        </Grid>

                            {tireSpeed}

                <Grid className={'gridHeader'} item xs={12}>
                            <div className={"tableHeader"}>Load Range</div>
                </Grid>

                            {tireRange}

                <Grid className={'gridHeader'} item xs={12}>
                            <div className={"tableHeader"}>Mileage Warranty</div>
                </Grid>

                            {tireWarranty}

                <Grid className={'gridHeader'} item xs={12}>
                            <div className={"tableHeader"}>GM Part Number</div>
                </Grid>

                        {tireGmPartNum}

            </Grid>
            </div>

        </>
    );
};

export default CompareTires;
